import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/knowledgehub.css";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { motion } from "framer-motion"; // Import Framer Motion

const Knowledgehub = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="knowledgeHub-container">
      {/* Animated Back Button */}
      <motion.div transition={{ duration: 0.3 }}>
        <IoMdArrowRoundBack
          className="back-icon"
          onClick={() => navigate(-1)}
          style={{
            position: "absolute",
            top: "20px",
            left: "30px",
            fontSize: "2rem",
            color: "#B3FF00",
            cursor: "pointer",
          }}
        />
      </motion.div>

      {/* Animated Horizontal Line */}
      <motion.hr
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      />

      {/* Animated Title */}
      <motion.h3
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        Welcome to the commceed Knowledge Hub
      </motion.h3>

      {/* Animated Intro Text */}
      <motion.p
        className="KnowledgeHubintro-text"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeInOut", delay: 0.2 }}
      >
        At commceed, we believe that the foundation of every successful project
        starts with knowledge. Our Knowledge Hub is your go-to resource for
        insightful information, expert advice, and the latest trends in cabling,
        network infrastructure, and IT solutions. Whether you're a business
        leader, an IT professional, or a contractor, our hub is designed to
        empower you with the tools and understanding needed to make informed
        decisions.
      </motion.p>

      {/* Animated "What We Offer" Section */}
      <motion.h3
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.2, ease: "easeInOut", delay: 0.4 }}
      >
        What We Offer
      </motion.h3>

      {/* Staggered List Items */}
      <motion.ul
        initial="hidden"
        animate="visible"
        transition={{ staggerChildren: 0.2 }}
      >
        {[
          {
            title: "Industry Insights",
            desc: "Stay up-to-date with the latest innovations and trends shaping the world of communications, networking, and IT. Our articles, case studies, and whitepapers provide a deep dive into emerging technologies and best practices that can elevate your projects.",
          },
          {
            title: "Expert Guidance",
            desc: "Gain access to expert tips and advice from our experienced team. Whether you need technical guidance on cabling standards, tips for optimizing your network, or assistance with installation best practices, we’ve got you covered.",
          },
          {
            title: "Product Knowledge",
            desc: "Explore detailed product information, including specifications, installation guides, and usage tips. Our comprehensive product resources help you select the best solutions tailored to your specific needs.",
          },
          {
            title: "Solutions and Case Studies",
            desc: "Learn how businesses across various industries have successfully implemented Commseed solutions. Our case studies showcase real-world applications and highlight how our products and services solve complex challenges.",
          },
          {
            title: "Interactive Tools and Resources",
            desc: "Discover calculators, product finders, and other interactive tools that simplify your decision-making process. With easy access to resources like cable length calculators and configuration guides, planning and executing your projects becomes a breeze.",
          },
        ].map((item, index) => (
          <motion.li
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 1.2,
              ease: "easeInOut",
              delay: 0.6 + index * 0.2,
            }}
          >
            <span className="bullet">&#8226;</span>
            <strong> {item.title} </strong>
            <p className="insights">{item.desc}</p>
          </motion.li>
        ))}
      </motion.ul>
    </div>
  );
};

export default Knowledgehub;
